import React from "react";
import Table from "../../Common/Table";
import { getPath } from "../../../utils";
import BlankState from "../../Common/BlankState";
import TableFields from "../../../constants/Inventories/TableFields.json";
import styled from "styled-components";

const InventoriesList = ({ inventoriesList }) => {
  const getFieldValue = (item, key) => {
    return key === "start_time" || key === "end_time" || key === "last_used_at"
      ? item[key] === "1970-01-01T00:00:00Z"
        ? "-"
        : item[key].replace("T", " ").replace("Z", "")
      : item[key];
  };

  return getPath(inventoriesList, "length", undefined) > 0 ? (
    <Table
      list={inventoriesList}
      fields={TableFields}
      getFieldValue={getFieldValue}
    />
  ) : (
    <BlankState />
  );
};

export default InventoriesList;
